import { render, staticRenderFns } from "./newManagementStandardOfFranchiseeQS.vue?vue&type=template&id=4b69b75d&scoped=true"
import script from "./newManagementStandardOfFranchiseeQS.vue?vue&type=script&lang=js"
export * from "./newManagementStandardOfFranchiseeQS.vue?vue&type=script&lang=js"
import style0 from "./newManagementStandardOfFranchiseeQS.vue?vue&type=style&index=0&id=4b69b75d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b69b75d",
  null
  
)

export default component.exports